import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { authAtom, targetPathAtom, userInfoAtom } from "../atom";
import { getFirstAvailableRoute } from "../utils/helper";
import { navItems } from "../utils/NavItems";

const NonPrivateRoute = ({ children }: any) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [authState, setAuthState] = useRecoilState(authAtom);
  const [pathName, setPathName] = useRecoilState(targetPathAtom);
  const userInfo = useRecoilValue(userInfoAtom);

  useEffect(() => {
    // Check if the user is already authenticated when the component mounts
    if (authState.is_auth && authState.auth_token && userInfo) {
      // Redirect the authenticated user to first available route based on permissions
      setPathName(location.pathname);
      const userPermissions = userInfo?.permissions || [];
      const redirectRoute = userInfo?.channel_partner
        ? getFirstAvailableRoute(navItems, userInfo, userPermissions)
        : "/order-analytics";
      navigate(redirectRoute);
    }
  }, [authState.is_auth, authState.auth_token, userInfo, navigate]);

  return <main>{children}</main>;
};

export default NonPrivateRoute;
